var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgKorzinka(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.6867 39.9999C25.2892 39.9999 25.7776 39.5115 25.7776 38.909C25.7776 38.3065 25.2892 37.8181 24.6867 37.8181C24.0842 37.8181 23.5958 38.3065 23.5958 38.909C23.5958 39.5115 24.0842 39.9999 24.6867 39.9999Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.2876 39.9999C37.8901 39.9999 38.3785 39.5115 38.3785 38.909C38.3785 38.3065 37.8901 37.8181 37.2876 37.8181C36.6851 37.8181 36.1967 38.3065 36.1967 38.909C36.1967 39.5115 36.6851 39.9999 37.2876 39.9999Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7812 16H16.1194C18.0677 16 19.7325 17.4036 20.0619 19.3238L22.1026 31.2217C22.4319 33.1418 24.0968 34.5455 26.045 34.5455H38.3787",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.557 30.1817H37.948C38.0621 30.1818 38.1728 30.1381 38.2611 30.0582C38.3494 29.9783 38.4099 29.867 38.4323 29.7433L40.2093 19.9251C40.2237 19.8459 40.2219 19.7642 40.2042 19.6859C40.1865 19.6076 40.1533 19.5345 40.107 19.4721C40.0606 19.4097 40.0023 19.3594 39.9363 19.3249C39.8702 19.2904 39.798 19.2725 39.725 19.2726H20.5825",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M34 17C34 12.0294 38.0294 8 43 8V8C47.9706 8 52 12.0294 52 17V17C52 21.9706 47.9706 26 43 26V26C38.0294 26 34 21.9706 34 17V17Z",
    fill: "#FC5468"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M43.0051 21.132C42.3011 21.132 41.7474 20.8167 41.3441 20.186C40.9481 19.548 40.7501 18.6423 40.7501 17.469C40.7501 16.2883 40.9481 15.39 41.3441 14.774C41.7474 14.158 42.3011 13.85 43.0051 13.85C43.7018 13.85 44.2481 14.158 44.6441 14.774C45.0474 15.39 45.2491 16.2883 45.2491 17.469C45.2491 18.6423 45.0474 19.548 44.6441 20.186C44.2481 20.8167 43.7018 21.132 43.0051 21.132ZM43.0051 20.406C43.4158 20.406 43.7458 20.175 43.9951 19.713C44.2444 19.2437 44.3691 18.4957 44.3691 17.469C44.3691 16.4423 44.2444 15.7053 43.9951 15.258C43.7458 14.8033 43.4158 14.576 43.0051 14.576C42.5944 14.576 42.2608 14.8033 42.0041 15.258C41.7548 15.7053 41.6301 16.4423 41.6301 17.469C41.6301 18.4957 41.7548 19.2437 42.0041 19.713C42.2608 20.175 42.5944 20.406 43.0051 20.406Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKorzinka);
export default __webpack_public_path__ + "static/media/korzinka.ad455c6d6021a5ec4624786fa13c371b.svg";
export { ForwardRef as ReactComponent };